import initLogoAndTitle from "./initLogoAndTitle.js";
import {
  initContactInfoDiv,
  initOpeningHoursDiv,
} from "./initInfoDivFromData.js";

export default function initFooter(contentDiv) {
  const footer = document.createElement("footer");
  footer.classList.add("main-footer");

  const footerContent = document.createElement("div");
  footerContent.classList.add("footer-content");
  footer.appendChild(footerContent);

  // Append the logo and the title
  footerContent.appendChild(initLogoAndTitle(contentDiv));

  // Add contact info div
  footerContent.appendChild(initContactInfoDiv());

  // Add opening hours info div
  footerContent.appendChild(initOpeningHoursDiv(true));

  // Add image credit
  footer.appendChild(initImageCredit());

  return footer;
}

function initImageCredit() {
  const imgCreditDiv = document.createElement("div");
  imgCreditDiv.classList.add("img-credit");

  imgCreditDiv.innerHTML = `Images used in this portfolio demo are sourced from free stock photo websites for demonstration purposes only.`;

  return imgCreditDiv;
}

function getAnchorStr(label, link) {
  return `<a href="${link}" target="_blank">${label}</a>`;
}
